import React from 'react';
import { useSelector } from 'react-redux';

export const Rating = ({ level, hideOutOf }) => {
    const ratingsRange = useSelector(state => state.user.user.companySettings?.display?.ratingRange || 5);

    return (
        <span className={`label label-rating label-rating-${level}`}>
            {level} {!hideOutOf && <>/ {ratingsRange}</>}
        </span>
    );
};

export default Rating;
